import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import { Icon, buttonsV2 as Buttons } from '@breezeway/brzw-components';

import './mobile_flyout_select.scss';

const {
  BUTTON_THEMES: { ICON_SUBTLE, SUBTLE },
  BUTTON_SIZES: { ICON_MEDIUM, LARGE },
} = Buttons.constants;
export const CLASS_NAME = 'mobile-flyout-select';

class MobileFlyoutSelect extends PureComponent {
  constructor(props) {
    super(props);

    this.parentContainer = document.querySelector(props.parentContainer);

    this.state = {
      isSelectOpen: false,
      selectPosition: this.getSelectPosition(),
    };

    this.checkPositionOnResize = this.checkPositionOnResize.bind(this);
    this.handleToggleSelect = this.handleToggleSelect.bind(this);
    this.getSelectedLabel = this.getSelectedLabel.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.renderLabel = this.renderLabel.bind(this);
    this.renderOptionsList = this.renderOptionsList.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.checkPositionOnResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkPositionOnResize);
  }

  getSelectPosition() {
    if (!this.parentContainer) return null;

    const containerRect = this.parentContainer.getBoundingClientRect();

    return {
      transform: `translate3d(${containerRect.left}px, 0, 0)`,
      width: `${containerRect.width}px`,
    };
  }

  getSelectedLabel() {
    const { value, options } = this.props;

    return _.get(
      _.first(value ? _.filter(options, item => item.value === value) : options),
      'label',
    );
  }

  checkPositionOnResize() {
    this.setState({
      selectPosition: this.getSelectPosition(),
    });
  }

  handleToggleSelect() {
    const { isSelectOpen } = this.state;

    this.setState({ isSelectOpen: !isSelectOpen });
  }

  handleSelect(value) {
    const { options, onSelect } = this.props;

    return () => {
      onSelect(_.first(_.filter(options, item => item.value === value)));
      this.handleToggleSelect();
    };
  }

  renderLabel() {
    const { label, withClose } = this.props;

    return (
      label && (
        <div className={`${CLASS_NAME}__select-label`}>
          {withClose && (
            <Buttons.IconButton
              className={`${CLASS_NAME}__select-label-icon`}
              iconName="close"
              onClick={this.handleToggleSelect}
              size={ICON_MEDIUM}
              theme={ICON_SUBTLE}
            />
          )}
          {label}
        </div>
      )
    );
  }

  renderOptionsList() {
    const { options } = this.props;

    return (
      <div className={`${CLASS_NAME}__options-content`}>
        {_.map(options, ({ label, value }) => (
          <Buttons.TextButton
            className={`${CLASS_NAME}__button`}
            alignment="left"
            fullWidth
            key={value}
            onClick={this.handleSelect(value)}
            size={LARGE}
            theme={SUBTLE}
          >
            {label}
          </Buttons.TextButton>
        ))}
      </div>
    );
  }

  render() {
    const { className, placeholder } = this.props;
    const { isSelectOpen, selectPosition } = this.state;

    return (
      <div className={classnames(CLASS_NAME, className)}>
        <div
          className={`${CLASS_NAME}__input`}
          onClick={this.handleToggleSelect}
          role="presentation"
        >
          <input
            className={`${CLASS_NAME}__input`}
            placeholder={placeholder}
            readOnly
            value={this.getSelectedLabel()}
          />
          <Icon className={`${CLASS_NAME}__icon`} iconName="chevron-down" />
        </div>

        <div
          className={classnames(`${CLASS_NAME}__select-container`, {
            [`${CLASS_NAME}__select-container--open`]: isSelectOpen,
          })}
        >
          <div className={`${CLASS_NAME}__select-content`} style={selectPosition}>
            {this.renderLabel()}
            {this.renderOptionsList()}
          </div>
          <div className={`${CLASS_NAME}__select-overlay`} style={selectPosition} />
        </div>
      </div>
    );
  }
}

MobileFlyoutSelect.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  parentContainer: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  withClose: PropTypes.bool,
};

MobileFlyoutSelect.defaultProps = {
  withClose: true,
};

export default MobileFlyoutSelect;
